module.exports = __webpack_public_path__ + "img/logoR6.45bc907e.png";